/**
 * We should be able to mock / stub browser apis but they are problematic
 * in tests. So we abstract them away with these helpers.
 *
 * Note: difficult to write tests for these.
 */

/**
 * A proxy for window.open
 */
export const windowOpen = (...args: Parameters<typeof window.open>) =>
  window.open(...args);

/**
 * Returns the location object for the top or self window
 */
export const topLocation = (): Location => (window.top ?? window).location;

/**
 * Appends a given page title to the document
 */
export const setTitle = (title = "") => {
  const siteTitle = import.meta.env.VITE_SITE_TITLE as string;
  window.document.title = title ? `${siteTitle} | ${title}` : siteTitle;
};
